import { Button, FlexLayout, H3, Icon } from '@deity-io/portal-ui';
import { CreateEditPackageModal } from 'components/Packages/CreateEditPackageModal';
import type { FC } from 'react';
import { useState } from 'react';

type PackagesHeaderProps = {
  onPackageCreated: () => void;
};
export const PackagesHeader: FC<PackagesHeaderProps> = ({ onPackageCreated }) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <>
      <FlexLayout sx={{ py: 5 }} justifyContent="space-between" alignItems="center">
        <H3 color="primaryText" fontWeight="regular">
          Packages
        </H3>
        <Button variant="outlined" onClick={() => setModalOpen(true)} startIcon={<Icon icon="add" />}>
          New package
        </Button>
      </FlexLayout>
      {modalOpen && (
        <CreateEditPackageModal
          isOpen={modalOpen}
          setOpenState={state => setModalOpen(state)}
          onPackageCreated={onPackageCreated}
        />
      )}
    </>
  );
};
